import React, {useState} from 'react';
import {H2} from '../../../components/crousal/Headings';
import {Button, ButtonType, ButtonSize} from '../../../components/crousal/Button';
import {TextInput} from '../../../components/crousal/TextInput';
import {IRanks, IRegions} from '../../../common/types/RegionsAndRanks';
import {SelectInput} from '../../../components/crousal/SelectInput';

interface IProps {
    onChange: (step: number) => void;
    regions: IRegions[];
    ranks: IRanks[];
}

export function Step2b({onChange, regions, ranks}: IProps) {
    const [champions, setChampions] = useState('');
    const [skins, setSkins] = useState('');
    const [blueEssence, setBlueEssence] = useState('');

    const [region, setRegion] = useState('');
    const [rank, setRank] = useState('');
    const [level, setLevel] = useState('');
    const regexToRetrieveNumbersOnly = /\D/g;

    function handleNext() {
        onChange(3);
    }

    return (
        <div>
            <H2 className="ml-4">Step 2 - Describe your account</H2>
            <div
                className="items-center lg:mt-6 text-30 flex justify-center lg:w-1/2 text-sm lg:mx-auto text-center">
                Please describe your accounts using selectors below. The account will be automatically posted.
                Keep in mind that these kind of accounts are sold in the order of posting. If there is more accounts of
                the exact same
                quality like yours it might have to wait before its sold.
            </div>
            <div className="flex justify-center text-center items-center mt-4">
                <div className={"w-48"}>
                    <TextInput
                        placeholder="Champions"
                        value={champions}
                        onChange={(champions) => setChampions(champions.replace(regexToRetrieveNumbersOnly, ''))}
                        applyBorder={true}
                    />
                </div>
                <div className={"w-48"}>
                    <TextInput
                        placeholder="Skins"
                        value={skins}
                        onChange={(skins) => setSkins(skins.replace(regexToRetrieveNumbersOnly, ''))}
                        className="ml-6"
                        applyBorder={true}
                    />
                </div>

                <div className={"w-48"}>
                    <TextInput
                        placeholder="Blue Essence"
                        value={blueEssence}
                        onChange={(blueEssence) => setBlueEssence(blueEssence.replace(regexToRetrieveNumbersOnly, ''))}
                        className="ml-6"
                        applyBorder={true}
                    />
                </div>
            </div>
            <div className="flex justify-center text-center items-center mt-4">
                <div className={"w-48"}>
                    <TextInput
                        placeholder="Level"
                        value={level}
                        onChange={(level) => setLevel(level.replace(regexToRetrieveNumbersOnly, ''))}
                        applyBorder={true}
                    />
                </div>
                <div className={"w-48"}>
                    <SelectInput
                        value={rank}
                        onChange={setRank}
                        options={ranks}
                        placeholder="Ranks"
                        className="ml-6 mt-2"
                        isPackageSelectBox={true}
                    />
                </div>
                <div className={"w-48"}>
                    <SelectInput
                        value={region}
                        onChange={setRegion}
                        options={regions}
                        placeholder="Server"
                        className="ml-6 mt-2"
                        isPackageSelectBox={true}
                    />
                </div>
            </div>
            <div className="mt-6 mb-10 text-md">
                <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleNext}>
                    Next
                </Button>
            </div>
        </div>
    );
}
